/**
 * Malcriados · landing Memorial: catalogo con pestañas y filtro de mascotas.
 *
 * Igual que el catalogo de la tienda, el servidor pinta todos los productos con su precio por
 * numero de retratos en data-precio-N (snippets/mc-tarjeta-producto.liquid). Aqui solo se
 * cambia lo visible:
 *
 * - Pestañas (data-mc-mem-pestana): muestran una coleccion (data-mc-mem-grupo). Parte la primera.
 * - Filtro "N° de mascotas" (data-mc-caritas): muestra el precio y la foto de esa cantidad y
 *   oculta los productos que no la tienen. Tocar el mismo numero lo quita.
 *
 * Sin JS se ven todas las colecciones, una debajo de otra.
 */

/**
 * La foto de la tarjeta sigue al filtro: mc-tarjeta.js la cambia a la de esa cantidad.
 * @param {HTMLElement} tarjeta
 * @param {number} n  0 = sin filtro
 */
function avisarRetratos(tarjeta, n) {
  const actual = tarjeta.dataset.mcN ?? '';
  const nuevo = n ? String(n) : '';
  if (actual === nuevo) return;
  if (nuevo) tarjeta.dataset.mcN = nuevo;
  else delete tarjeta.dataset.mcN;
  tarjeta.dispatchEvent(new CustomEvent('mc:retratos', { bubbles: true }));
}

/**
 * @param {HTMLElement} tarjeta
 * @param {number} n
 * @param {HTMLElement} raiz
 * @returns {boolean} true si la tarjeta queda visible
 */
function pintarTarjeta(tarjeta, n, raiz) {
  const precio = tarjeta.querySelector('[data-mc-precio]');
  const detalle = tarjeta.querySelector('[data-mc-detalle]');
  const desde = tarjeta.querySelector('[data-mc-desde]');

  if (!n) {
    tarjeta.hidden = false;
    avisarRetratos(tarjeta, 0);
    if (precio instanceof HTMLElement) precio.textContent = precio.dataset.base || '';
    if (detalle instanceof HTMLElement) detalle.textContent = detalle.dataset.base || '';
    if (desde instanceof HTMLElement) desde.hidden = false;
    return true;
  }

  const precioN = tarjeta.getAttribute(`data-precio-${n}`);
  if (precioN === null) {
    tarjeta.hidden = true;
    return false;
  }
  tarjeta.hidden = false;
  avisarRetratos(tarjeta, n);
  if (precio) precio.textContent = precioN;
  if (detalle) {
    const plantilla = n === 1 ? raiz.dataset.textoUno : raiz.dataset.textoVarios;
    detalle.textContent = (plantilla || '').replaceAll('[n]', String(n));
  }
  if (desde instanceof HTMLElement) desde.hidden = true;
  return true;
}

/**
 * @param {HTMLElement} raiz
 * @param {string} grupo  handle de la coleccion activa
 * @param {number} n
 */
function aplicar(raiz, grupo, n) {
  raiz.dataset.mcGrupo = grupo;
  raiz.dataset.mcN = String(n);

  for (const pestana of raiz.querySelectorAll('[data-mc-mem-pestana]')) {
    pestana.setAttribute('aria-selected', String(pestana.getAttribute('data-mc-mem-pestana') === grupo));
  }
  for (const boton of raiz.querySelectorAll('[data-mc-caritas]')) {
    boton.setAttribute('aria-pressed', String(Number(boton.getAttribute('data-mc-caritas')) === n));
  }

  let visibles = 0;
  for (const cuadro of raiz.querySelectorAll('[data-mc-mem-grupo]')) {
    if (!(cuadro instanceof HTMLElement)) continue;
    const activo = cuadro.getAttribute('data-mc-mem-grupo') === grupo;
    let cuenta = 0;
    for (const tarjeta of cuadro.querySelectorAll('[data-mc-tarjeta]')) {
      if (tarjeta instanceof HTMLElement && pintarTarjeta(tarjeta, n, raiz)) cuenta += 1;
    }
    cuadro.hidden = !activo || cuenta === 0;
    if (activo) visibles = cuenta;
  }

  const vacio = raiz.querySelector('[data-mc-mem-vacio]');
  if (vacio instanceof HTMLElement) vacio.hidden = visibles > 0;
  const conteo = raiz.querySelector('[data-mc-mem-conteo]');
  if (conteo) {
    conteo.textContent = `${visibles} ${visibles === 1 ? 'producto' : 'productos'}${n ? ` para ${n} ${n === 1 ? 'mascota' : 'mascotas'}` : ''}`;
  }
}

/** @param {HTMLElement} raiz */
function iniciar(raiz) {
  const primero = raiz.querySelector('[data-mc-mem-grupo]');
  const grupo = primero instanceof HTMLElement ? primero.getAttribute('data-mc-mem-grupo') || '' : '';
  aplicar(raiz, grupo, 0);
}

document.addEventListener('click', (evento) => {
  const origen = evento.target instanceof Element ? evento.target : null;
  const raiz = origen?.closest('[data-mc-mem-catalogo]');
  if (!origen || !(raiz instanceof HTMLElement)) return;

  const grupo = raiz.dataset.mcGrupo || '';
  const n = Number(raiz.dataset.mcN || 0);

  const pestana = origen.closest('[data-mc-mem-pestana]');
  if (pestana) {
    aplicar(raiz, pestana.getAttribute('data-mc-mem-pestana') || grupo, n);
    return;
  }

  const boton = origen.closest('[data-mc-caritas]');
  if (boton) {
    const elegido = Number(boton.getAttribute('data-mc-caritas'));
    aplicar(raiz, grupo, n === elegido ? 0 : elegido);
  }
});

function iniciarTodo() {
  for (const raiz of document.querySelectorAll('[data-mc-mem-catalogo]')) {
    if (raiz instanceof HTMLElement) iniciar(raiz);
  }
}

/* El editor de temas vuelve a pintar la seccion. */
document.addEventListener('shopify:section:load', iniciarTodo);
iniciarTodo();
